<template>
    <div>
        <div :class="{ 'horizontal-list-card' : true, 'mb-3' : index !== 4 }" v-for="index in 4" :key="index" >
            <PlaceHolderLoader height="12px" width="100%" :custom-class="['mb-2 rounded']" />
            <PlaceHolderLoader height="12px" width="100%" :custom-class="['mb-2 rounded']" />
            <PlaceHolderLoader height="12px" width="100%" :custom-class="['mb-2 rounded']" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HorizontalListLoader'
    }
</script>

<style lang="scss" scoped>
.horizontal-list-card {
    height: 110px;
}
</style>